export const Vertical = {
    SKIN: 'Skin',
    WEIGHT_LOSS: 'Weight Loss',
} as const;
export type Vertical = (typeof Vertical)[keyof typeof Vertical];

type VerticalByParam = {
    [key: string]: Vertical | undefined;
};

export const verticalByParam: VerticalByParam = {
    skin: Vertical.SKIN,
    'weight-loss': Vertical.WEIGHT_LOSS,
};
